/* Homepage logo: swap to high-res 2500px CDN variant */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  function rewriteLogoSrc() {
    var picture = document.querySelector('.site-header__logo picture');
    var img = document.querySelector('.site-header__logo img');
    if (!img) return;

    var base = (img.currentSrc || img.src || '').split('?')[0];
    if (!base) return;

    if (picture) {
      picture.querySelectorAll('source').forEach(function (s) { s.remove(); });
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = base + '?width=2500';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteLogoSrc);
  } else {
    rewriteLogoSrc();
  }
})();

/* Hide header on scroll-down, show on scroll-up (desktop only) */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    if (window.innerWidth < 769) return;

    var lastY = window.scrollY;
    var ticking = false;
    var HIDE_THRESHOLD = 150;

    function update() {
      var y = window.scrollY;
      if (y > lastY && y > HIDE_THRESHOLD) {
        wrapper.classList.add('header-hidden-on-scroll-down');
      } else if (y < lastY) {
        wrapper.classList.remove('header-hidden-on-scroll-down');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  });
})();

/* <go-back> — clicking sends the browser back one step in history.
   Ported from the old theme's product page "Go back" control. */
(function () {
  if (window.customElements && customElements.get('go-back')) return;

  class GoBack extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      this.addEventListener('click', function () { window.history.back(); });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.history.back();
        }
      });
    }
  }

  customElements.define('go-back', GoBack);
})();

/* Mobile drawer language selector: the theme's HeaderSection.initDisclosures()
   only wires the locale disclosure found inside its section container,
   but the nav drawer (#NavDrawer) is rendered OUTSIDE that container — so
   the drawer's selector never gets a Disclosure instance and clicking it does nothing.
   Initialize it here using the theme's own Disclosure class. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initDrawerLocale() {
    if (!window.theme || !theme.Disclosure) return;
    var el = document.querySelector('#NavDrawer [data-disclosure-locale]');
    if (!el || el._drawerDisclosureInit) return;
    el._drawerDisclosureInit = true;
    new theme.Disclosure(el);
  }

  ready(initDrawerLocale);
  // Re-init if the header section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', initDrawerLocale);
})();

/* Collection filters + grid: respect real stock when filtering by size.
   Shopify's variant-option size filter (filter.v.option.size) matches any product that HAS a size variant, ignoring inventory.
   So (a) sold-out sizes still appear in the filter list, and (b) selecting a size still shows products whose that-size variant is out of stock.
   We fetch the collection's products and, using real per-variant availability, both hide unavailable size values and hide grid products whose selected size(s) aren't in stock.
   Fail-safe: if the product data can't be loaded, nothing is hidden. */
(function () {
  if (!document.body.classList.contains('template-collection')) return;

  var SIZE_PARAM = 'filter.v.option.size';
  var availableSizes = null; // Set of in-stock sizes across the collection.
  var productSizeMap = null; // handle -> Set of that product's in-stock sizes.
  var sizeCount = null;      // size -> number of products with that size in stock.
  var observer = null;       // watches AJAX filter/sort re-renders.
  var ajaxRoot = null;       // container the theme re-renders on filter/sort.

  function getHandle() {
    var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function sizeOptionPosition(product) {
    var pos = null;
    (product.options || []).forEach(function (o) {
      if (o.name && o.name.trim().toLowerCase() === 'size') pos = o.position;
    });
    return pos;
  }

  function fetchAllProducts(handle) {
    var all = [];
    function page(p) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + p, {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var prods = (d && d.products) || [];
          all = all.concat(prods);
          return prods.length === 250 ? page(p + 1) : all;
        })
        .catch(function () { return all; });
    }
    return page(1);
  }

  function computeData(products) {
    var sizes = new Set();
    var map = {};
    products.forEach(function (p) {
      var pos = sizeOptionPosition(p);
      if (!pos) return;
      var perProduct = new Set();
      (p.variants || []).forEach(function (v) {
        if (v.available) {
          var val = v['option' + pos];
          if (val != null) {
            val = String(val).trim();
            perProduct.add(val);
            sizes.add(val);
          }
        }
      });
      map[p.handle] = perProduct;
    });
    var counts = {};
    Object.keys(map).forEach(function (h) {
      map[h].forEach(function (sz) { counts[sz] = (counts[sz] || 0) + 1; });
    });
    availableSizes = sizes;
    productSizeMap = map;
    sizeCount = counts;
  }

  function activeSizes() {
    var set = new Set();
    document.querySelectorAll('input[name="' + SIZE_PARAM + '"]:checked').forEach(function (i) {
      set.add(String(i.value).trim());
    });
    return set;
  }

  function handleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var after = link.getAttribute('href').split('/products/')[1];
    return after ? after.split(/[?#\/]/)[0] : null;
  }

  // Sidebar filter list: hide sold-out sizes and correct each remaining "(n)" count to the real in-stock product count.
  // Only touches classes/text nodes, so it never trips the childList observer.
  function updateSidebar() {
    document.querySelectorAll('input[name="' + SIZE_PARAM + '"]').forEach(function (input) {
      var tag = input.closest('.tag');
      if (!tag) return;
      var val = String(input.value).trim();
      if (!availableSizes.has(val)) {
        tag.classList.add('hide');
        return;
      }
      var textEl = tag.querySelector('.tag__text');
      var wrapper = textEl && textEl.parentElement;
      if (wrapper) {
        var real = sizeCount[val] || 0;
        wrapper.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && /\(\s*\d+\s*\)/.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/\(\s*\d+\s*\)/, '(' + real + ')');
          }
        });
      }
    });
  }

  // ---- Grid: client-side pagination of the in-stock results, PAGE at a time.
  // Shopify paginates stock-blind, so simply removing sold-out cards leaves uneven pages (e.g. 7 of 12).
  // Instead we gather every in-stock card for the selected size(s) across all Shopify pages, then reveal them PAGE at a time so each page is a full, clean grid.
  var PAGE = 8;
  var pagerCards = []; // all in-stock card nodes for the active filter
  var pagerShown = 0;  // how many are currently revealed in the grid

  function inStock(card, active) {
    var handle = handleFromCard(card);
    var avail = handle && productSizeMap[handle];
    return avail && Array.from(active).some(function (sz) { return avail.has(sz); });
  }

  // Force primary images visible (moved/appended cards miss AOS/<image-element> reveal).
  // Skip the secondary (hover) image so hover still works.
  function forceRevealImages(scope) {
    scope.querySelectorAll('img').forEach(function (img) {
      if (!img.closest('.grid-product__secondary-image')) {
        img.style.setProperty('animation', 'none', 'important');
        img.style.setProperty('opacity', '1', 'important');
      }
    });
  }

  function setCounter(loadMore, shown, total) {
    if (!loadMore) return;
    var span = loadMore.querySelector('[data-load-more-count]');
    if (span) {
      span.textContent = shown;
      var p = span.parentElement;
      if (p) {
        p.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && /\/\s*\d+/.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/\/\s*\d+/, '/ ' + total);
          }
        });
      }
    }
    loadMore.setAttribute('data-total-items', String(total));
    var btn = loadMore.querySelector('.js-load-more');
    if (btn) {
      if (shown >= total) btn.setAttribute('hidden', '');
      else btn.removeAttribute('hidden');
    }
  }

  function revealNext(grid, loadMore) {
    pagerCards.slice(pagerShown, pagerShown + PAGE).forEach(function (c) { grid.appendChild(c); });
    pagerShown = Math.min(pagerShown + PAGE, pagerCards.length);
    forceRevealImages(grid);
    setCounter(loadMore, pagerShown, pagerCards.length);
  }

  function fetchPageCards(url, active) {
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('#CollectionAjaxContent .grid--uniform') || doc.querySelector('.grid--uniform');
        var cards = g ? Array.prototype.slice.call(g.querySelectorAll('.grid-product')).filter(function (c) { return inStock(c, active); }) : [];
        var lm = doc.querySelector('load-more');
        return { cards: cards, next: (lm && lm.getAttribute('data-next-url')) || '' };
      })
      .catch(function () { return { cards: [], next: '' }; });
  }

  function collectAllInStock(grid, loadMore, active) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.grid-product')).filter(function (c) { return inStock(c, active); });
    var nextUrl = loadMore ? loadMore.getAttribute('data-next-url') : '';
    var pages = 0;
    function step() {
      if (!nextUrl || pages >= 25) return Promise.resolve(cards); // cap: guard runaway
      pages++;
      return fetchPageCards(nextUrl, active).then(function (res) {
        cards = cards.concat(res.cards);
        nextUrl = res.next;
        return step();
      });
    }
    return step();
  }

  function renderPaginated(grid, loadMore, cards) {
    var seen = {};
    pagerCards = cards.filter(function (c) {
      var h = handleFromCard(c);
      if (!h || seen[h]) return false;
      seen[h] = 1;
      return true;
    });
    pagerShown = 0;
    grid.innerHTML = '';

    if (!loadMore) {
      // No pagination control — reveal everything at once.
      while (pagerShown < pagerCards.length) revealNext(grid, null);
      return;
    }

    // Mark this load-more as taken over so a stray re-run doesn't re-collect
    // (our blanked next-url would otherwise make it re-gather only page one).
    loadMore.setAttribute('data-pager-done', '1');
    revealNext(grid, loadMore); // first page

    // Take over the Load More button: the theme's handler fetches the next Shopify page,
    // but we already hold every in-stock card — so disable its fetch (blank next-url) and reveal our next slice instead.
    loadMore.setAttribute('data-next-url', '');
    var btn = loadMore.querySelector('.js-load-more');
    if (btn && !btn._pagerBound) {
      btn._pagerBound = true;
      btn.addEventListener('click', function () {
        if (observer) observer.disconnect();
        revealNext(grid, loadMore);
        if (observer && ajaxRoot) observer.observe(ajaxRoot, { childList: true, subtree: true });
      });
    }
  }

  var runToken = 0;

  function apply() {
    if (!availableSizes || !productSizeMap) return;
    updateSidebar(); // class/text edits only — safe with the observer connected

    var active = activeSizes();
    var grid = document.querySelector('#CollectionAjaxContent .grid--uniform');
    var loadMore = document.querySelector('#CollectionAjaxContent load-more');
    // Unfiltered: Shopify already paginates by 8, nothing to do.
    if (active.size === 0 || !grid) return;
    // Already paginated this (unchanged) grid — a fresh filter/sort render gives a new load-more without this flag, so real changes still re-run.
    if (loadMore && loadMore.hasAttribute('data-pager-done')) return;

    var myToken = ++runToken;
    collectAllInStock(grid, loadMore, active).then(function (cards) {
      if (myToken !== runToken) return; // a newer filter change superseded this run
      if (observer) observer.disconnect();
      renderPaginated(grid, loadMore, cards);
      if (observer && ajaxRoot) observer.observe(ajaxRoot, { childList: true, subtree: true });
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var handle = getHandle();
    if (!handle) return;

    // Watch for AJAX filter/sort updates that re-render the content, then re-apply (debounced).
    // apply() pauses this observer around its own edits.
    ajaxRoot = document.querySelector('#CollectionAjaxContent') || document.body;
    var t;
    observer = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 60);
    });
    observer.observe(ajaxRoot, { childList: true, subtree: true });

    fetchAllProducts(handle).then(function (products) {
      if (!products || !products.length) return; // fail-safe: leave everything as-is
      computeData(products);
      apply();
    });
  });
})();

/* Nav hover backdrop: size a dark panel to hug the menu + active submenu.
   JS only measures and writes --nav-bd-* vars; the CSS ::before animates. */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    if (window.innerWidth < 769) return;
    var header = document.querySelector('.site-header');
    var navList = header && header.querySelector('.site-navigation');
    if (!navList) return;

    var PAD = 14; // extra depth below an open submenu

    // Depth from the header top down to the deepest visible item:
    // the header's own bottom, or the open submenu's bottom if lower.
    function setBackdrop(item) {
      var dropdown = item.querySelector('.site-nav__dropdown');
      // measure after layout settles (submenu reveals on hover)
      requestAnimationFrame(function () {
        var h = header.getBoundingClientRect();
        var bottom = h.bottom;
        if (dropdown) {
          var d = dropdown.getBoundingClientRect();
          if (d.width && d.height) bottom = Math.max(bottom, d.bottom + PAD);
        }
        header.style.setProperty('--nav-bd-h', (bottom - h.top) + 'px');
        header.classList.add('is-backdrop-active');
      });
    }

    navList.querySelectorAll('.site-nav__item').forEach(function (item) {
      item.addEventListener('mouseenter', function () { setBackdrop(item); });
    });

    navList.addEventListener('mouseleave', function () {
      header.classList.remove('is-backdrop-active');
    });
  });
})();

/* Cart drawer: make the per-item "Remove" link remove in place (AJAX) instead of navigating to /cart.
   The theme only wired removal through the qty stepper, and its quantityChanged handler rejects qty 0 (`if (!key || !qty) return`),
   so we call theme.cart.changeItem(key, 0) directly and let the theme rebuild every cart view via its 'cart:build' hook (which also refreshes the count bubble).
   Delegated + scoped to #CartDrawer because the drawer re-renders its items after every change, and so the cart page's own Remove links keep their behaviour. */
(function () {
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var link = target.closest('#CartDrawer .cart__remove a');
    if (!link) return;

    e.preventDefault();
    var href = link.getAttribute('href');

    // If the theme cart API isn't available, fall back to normal navigation.
    if (!window.theme || !theme.cart || typeof theme.cart.changeItem !== 'function') {
      window.location.href = href;
      return;
    }

    // Prefer the line-item key from the row; fall back to the href's id param.
    var row = link.closest('.cart__item');
    var key = row ? row.getAttribute('data-key') : null;
    if (!key) {
      var match = href.match(/[?&]id=([^&]+)/);
      key = match ? decodeURIComponent(match[1]) : null;
    }
    if (!key) { window.location.href = href; return; }

    link.classList.add('is-loading');
    theme.cart.changeItem(key, 0)
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        // Network/API failure — let the browser do the plain removal instead.
        window.location.href = href;
      });
  });
})();

/* Featured collection carousels: click-and-drag horizontal scrolling with a mouse.
   Native overflow-x scrolls via trackpad/wheel but not mouse drag, so translate pointer drags into scrollLeft.
   Touch is left to native scrolling (mouse pointers only), and a drag past a small threshold swallows the following click so it doesn't open a product. */
(function () {
  var THRESHOLD = 5; // px of travel before it counts as a drag, not a click
  var WRAPPER_SELECTOR = '[data-context="featured-collection"] .grid-overflow-wrapper';

  var FRICTION = 0.92;      // per-frame velocity decay (higher = longer glide)
  var MIN_VELOCITY = 0.5;   // px/frame; momentum stops below this
  var STALE_MS = 60;        // paused longer than this before release => no fling

  function bind(wrapper) {
    if (wrapper._dragScrollBound) return;
    wrapper._dragScrollBound = true;

    var isDown = false, moved = false, startX = 0, startScroll = 0;
    var lastX = 0, lastMoveT = 0, velocity = 0; // velocity: client-space px/frame
    var momentumId = null;

    function stopMomentum() {
      if (momentumId) { cancelAnimationFrame(momentumId); momentumId = null; }
    }

    function momentum() {
      wrapper.scrollLeft -= velocity;
      velocity *= FRICTION;

      var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      var atEdge = wrapper.scrollLeft <= 0 || wrapper.scrollLeft >= maxScroll;
      if (Math.abs(velocity) < MIN_VELOCITY || atEdge) {
        stopMomentum();
        return;
      }
      momentumId = requestAnimationFrame(momentum);
    }

    wrapper.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // native touch scroll handles this
      stopMomentum();                        // a fresh grab cancels any glide
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = wrapper.scrollLeft;
      lastX = e.clientX;
      lastMoveT = performance.now();
      velocity = 0;
      wrapper.classList.add('is-dragging');
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      // Capture only once this is a real drag: capturing on pointerdown retargets the
      // click to the wrapper, so a plain click never reaches the product link.
      if (!moved && Math.abs(dx) > THRESHOLD) {
        moved = true;
        if (wrapper.setPointerCapture) {
          try { wrapper.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        }
      }
      wrapper.scrollLeft = startScroll - dx;

      // Smoothed recent velocity for the fling (weight the latest movement).
      var step = e.clientX - lastX;
      velocity = 0.7 * velocity + 0.3 * step;
      lastX = e.clientX;
      lastMoveT = performance.now();
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      wrapper.classList.remove('is-dragging');

      // Fling only if the pointer was still moving when released.
      var stale = performance.now() - lastMoveT > STALE_MS;
      if (moved && !stale && Math.abs(velocity) >= MIN_VELOCITY) {
        momentumId = requestAnimationFrame(momentum);
      }
    }
    wrapper.addEventListener('pointerup', endDrag);
    wrapper.addEventListener('pointercancel', endDrag);

    // Swallow the click that follows a real drag (capture phase, before the link).
    wrapper.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    // Stop the browser's native image/link ghost-drag while scrubbing.
    wrapper.addEventListener('dragstart', function (e) {
      if (isDown) e.preventDefault();
    });
  }

  function init(root) {
    (root || document).querySelectorAll(WRAPPER_SELECTOR).forEach(bind);
  }

  init(document);
  // Re-bind when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Scrolling-text → click to reveal an inline newsletter field (opt-in per section).
   Clicking the marquee hides it and shows a bare email input styled like the text.
   Submit posts via AJAX (optimistic) to the customer form and shows a thank-you,
   then reverts. Esc, or a click away while the field is empty, reverts to the marquee. */
(function () {
  var REVERT_MS = 3000;

  function bind(container) {
    if (container._marqueeSubscribeBound) return;
    container._marqueeSubscribeBound = true;

    var marquee = container.querySelector('[data-marquee]');
    var form = container.querySelector('form');
    var input = container.querySelector('[data-subscribe-input]');
    var thanks = container.querySelector('[data-subscribe-thanks]');
    if (!marquee || !form || !input) return;

    var revertTimer = null;

    function reset() {
      input.removeAttribute('hidden');
      input.value = '';
      if (thanks) thanks.setAttribute('hidden', '');
    }

    function open() {
      clearTimeout(revertTimer);
      reset();
      // Pin the container to the marquee's height (captured while it's still
      // visible) so hiding the text with display:none doesn't collapse the bar.
      container.style.minHeight = marquee.offsetHeight + 'px';
      container.classList.add('is-subscribing');
      window.requestAnimationFrame(function () { input.focus(); });
    }

    function close() {
      clearTimeout(revertTimer);
      container.classList.remove('is-subscribing');
      container.style.minHeight = '';
      reset();
    }

    marquee.addEventListener('click', open);
    marquee.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); }
    });

    // Click away while empty reverts to the marquee.
    document.addEventListener('click', function (e) {
      if (!container.classList.contains('is-subscribing')) return;
      if (container.contains(e.target)) return;
      if (input.value.trim() === '') close();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) {
        if (form.reportValidity) form.reportValidity();
        return;
      }
      // Optimistic: post in the background, then show the thank-you regardless of the (opaque) storefront response.
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      }).catch(function () { /* ignore — still confirm optimistically */ })
        .finally(showThanks);
    });

    function showThanks() {
      input.setAttribute('hidden', '');
      if (thanks) thanks.removeAttribute('hidden');
      clearTimeout(revertTimer);
      revertTimer = setTimeout(close, REVERT_MS);
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-marquee-subscribe]').forEach(bind);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
